
export default {
    statusCurso: {},
    statusCursos: []
}